import { TournamentFollowWithDetails } from '../models';
import { TournamentFollowRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetFollowedTournamentsUseCase {
  constructor(private tournamentFollowRepository: TournamentFollowRepository) {}

  async execute(
    userId: string,
    limit: number = 20,
    offset: number = 0
  ): Promise<TournamentFollowWithDetails[]> {
    logger.debug('GetFollowedTournaments', 'Getting followed tournaments', { userId });

    const tournaments = await this.tournamentFollowRepository.getFollowedTournaments(
      userId,
      limit,
      offset
    );

    logger.debug('GetFollowedTournaments', 'Found followed tournaments', { count: tournaments.length });

    return tournaments;
  }
}
